import {PHOTO_DECORATIONS} from './photo-catalog.js';

const clamp=(value,min,max)=>Math.max(min,Math.min(max,value));
export function layerScaleBounds(layer) {
  const photo=layer?.kind==='charm'?PHOTO_DECORATIONS.find(item=>item.id===layer.type):null;
  return photo?{min:photo.minSize/photo.defaultSize,max:photo.maxSize/photo.defaultSize}:{min:.1,max:3};
}
// The existing storage and server contract derives photo-charm scale from sizeMm.
// Keep both in sync; these are preview dimensions, not a confirmed inventory SKU.
export function layerScalePatch(layer,value) {
  const {min,max}=layerScaleBounds(layer);
  const scale=clamp(Number.isFinite(value)?value:layer.scale||1,min,max);
  const photo=layer?.kind==='charm'?PHOTO_DECORATIONS.find(item=>item.id===layer.type):null;
  return photo?{scale,sizeMm:scale*photo.defaultSize}:{scale};
}

export function layerPositionPatch(layer,dx,dy) {
  return {x:clamp(layer.x+dx,-60,160),y:clamp(layer.y+dy,-60,210)};
}
